module.exports = __webpack_public_path__ + "static/media/recurring-payment.289729db.png";